/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import '../Landing/Landing.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { get, post } from '../../services/https'
import { ToRial } from '../../services/money'

import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

import happyEmoji from '../../assets/svg/happyEmoji.svg'
import normalEmoji from '../../assets/svg/normalEmoji.svg'
import sadEmoji from '../../assets/svg/sadEmoji.svg'
import verySadEmoji from '../../assets/svg/verySadEmoji.svg'

export default function Comment() {
  const { id } = useParams()

  const navigate = useNavigate()

  const [qualitySelect, setQualitySelect] = useState('')
  const [peykSelect, setPeykSelect] = useState('')
  const [exprienceSelect, setExprienceSelect] = useState('')
  const [valueSelect, setValueSelect] = useState('')
  const [packagingSelect, setPackagingSelect] = useState('')

  const [order, setOrder] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [orderBasket, setOrderBasket] = useState([])
  const [statusPage, setStatusPage] = useState(false)
  const [orderStatus, setOrderStatus] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    get(`/api/front/order/details/${id}`)
      .then(response => {
        setOrder(response.data.data)
        setOrderBasket(response.data.data.basket)
        setStatusPage(true)

        switch(response.data.data.orderStatus) {
          case 'new':
            setOrderStatus('سفارش جدید')
            break
          case 'doing':
            setOrderStatus('سفارش در حال انجام')
            break
          case 'ready':
            setOrderStatus('سفارش آماده تحویل')
            break
          case 'done':
            setOrderStatus('تحویل داده شده')
            break
          case 'cancel':
            setOrderStatus('سفارش کنسل شده')
            break
          default :
            setOrderStatus('')
            break
        }
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [])

  const qualityFoodHandler = (e) => {
    setQualitySelect(e.target.id)
  }

  const peykFoodHandler = (e) => {
    setPeykSelect(e.target.id)
  }

  const onlineExperinceFoodHandler = (e) => {
    setExprienceSelect(e.target.id)
  }

  const valueFoodFoodHandler = (e) => {
    setValueSelect(e.target.id)
  }

  const packagingFoodFoodHandler = (e) => {
    setPackagingSelect(e.target.id)
  }


  const commentHandler = (e) => {
    e.preventDefault()

    if (qualitySelect === '') {
      notify('error', 'کیفیت غذا رو مشخص کنید')
    }

    if (peykSelect === '') {
      notify('error', 'برخورد پیک رو مشخص کنید')
    }

    if (exprienceSelect === '') {
      notify('error', 'تجربه سفارش آنلاین رو مشخص کنید')
    }

    if (valueSelect === '') {
      notify('error', 'حجم غذا رو مشخص کنید')
    }

    if (packagingSelect === '') {
      notify('error', 'بسته بندی غذا رو مشخص کنید')
    }

    if(qualitySelect !== '' &&
      peykSelect !== '' &&
      exprienceSelect !== '' &&
      valueSelect !== '' &&
      packagingSelect !== '') {
        post('/api/front/cc/comments/', {
          quality : parseInt(qualitySelect),
          peyk : parseInt(peykSelect),
          exprience : parseInt(exprienceSelect),
          value : parseInt(valueSelect),
          packaging : parseInt(packagingSelect),
          score : parseInt(qualitySelect) + parseInt(peykSelect) + parseInt(exprienceSelect) + parseInt(valueSelect) + parseInt(packagingSelect),
          order: id,
          message: message
        }).then(response => {
          notify('success', 'نظر شما ثبت شد')
          setTimeout(() => {
            navigate('/')
          }, 4000)
        }).catch(error => {
          if (error.response.data.errors === "قبلاً در نظرسنجی شرکت کردید") {
            notify('error', error.response.data.errors)
          } else {
            notify('error', error.response.data.messageFa)
          }
        })
      }
  }

  return (
    <div id='SignUp'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className="bill" style={statusPage ? { filter: 'blur(0px)' } : { filter: 'blur(5px)' }}>
          {order ? (
            <div className='refId' style={{ margin: '1em 0 0 0' }}>کد پرداخت : {order.refId}</div>
          ) : ''}
          {order ? (
            <div className='orderNumber'>شماره سفارش : {order.orderNumber}</div>
          ) : ''}
          {order ? (
            <div className='orderNumber'>پرداختی : {ToRial(String(order.total))} تومان</div>
          ) : ''}
          {order ? (
            <div className='orderStatus'>وضعیت سفارش : {orderStatus}</div>
          ) : ''}
          <hr />
          <form className='commentForm' action="">
            <div className='commentForm_title'>ضمن قدردانی از انتخاب شما ، لطفاً با ثبت نظر ما را در امر بهبود خدمات یاری فرمایید.</div>
            <div className="comments">
              <span>کیفیت غذا :</span>
              <span onClick={qualityFoodHandler}>
                <img style={qualitySelect === '4' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={happyEmoji} alt="happyEmoji" id="4" />
                <img style={qualitySelect === '3' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={normalEmoji} alt="normalEmoji"  id="3" />
                <img style={qualitySelect === '2' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={sadEmoji} alt="sadEmoji"  id="2" />
                <img style={qualitySelect === '1' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={verySadEmoji} alt="verySadEmoji"  id="1" />
              </span>
            </div>
            <div className="comments">
              <span>برخورد پیک :</span>
              <span onClick={peykFoodHandler}>
                <img style={peykSelect === '4' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={happyEmoji} alt="happyEmoji" id="4" />
                <img style={peykSelect === '3' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={normalEmoji} alt="normalEmoji"  id="3" />
                <img style={peykSelect === '2' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={sadEmoji} alt="sadEmoji"  id="2" />
                <img style={peykSelect === '1' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={verySadEmoji} alt="verySadEmoji"  id="1" />
              </span>
            </div>
            <div className="comments">
              <span>تجربه سفارش آنلاین :</span>
              <span onClick={onlineExperinceFoodHandler}>
                <img style={exprienceSelect === '4' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={happyEmoji} alt="happyEmoji" id="4" />
                <img style={exprienceSelect === '3' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={normalEmoji} alt="normalEmoji"  id="3" />
                <img style={exprienceSelect === '2' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={sadEmoji} alt="sadEmoji"  id="2" />
                <img style={exprienceSelect === '1' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={verySadEmoji} alt="verySadEmoji"  id="1" />
              </span>
            </div>
            <div className="comments">
              <span>حجم غذا :</span>
              <span onClick={valueFoodFoodHandler}>
                <img style={valueSelect === '4' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={happyEmoji} alt="happyEmoji" id="4" />
                <img style={valueSelect === '3' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={normalEmoji} alt="normalEmoji"  id="3" />
                <img style={valueSelect === '2' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={sadEmoji} alt="sadEmoji"  id="2" />
                <img style={valueSelect === '1' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={verySadEmoji} alt="verySadEmoji"  id="1" />
              </span>
            </div>
            <div className="comments">
              <span>بسته بندی :</span>
              <span onClick={packagingFoodFoodHandler}>
                <img style={packagingSelect === '4' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={happyEmoji} alt="happyEmoji" id="4" />
                <img style={packagingSelect === '3' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={normalEmoji} alt="normalEmoji"  id="3" />
                <img style={packagingSelect === '2' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={sadEmoji} alt="sadEmoji"  id="2" />
                <img style={packagingSelect === '1' ? { opacity: '1' } : { opacity: '0.5' }} className='commentsImage' src={verySadEmoji} alt="verySadEmoji"  id="1" />
              </span>
            </div>
            <div className="comments">
            <textarea style={{ width: '100%', border: '1px solid' }} cols={3} rows={3} onChange={e => setMessage(e.target.value)} name='' id='from' placeholder='پیغام شما ...'></textarea>
            </div>

            <button onClick={commentHandler}>
              ثبت نظر
            </button>
          </form>
        </div>
      </div>
      <Footer page={''} />
    </div>
  )
}
